import { Controller } from "@hotwired/stimulus"

// Click-to-play video facade (the pattern web.dev / lite-youtube-embed recommend):
// the cell shows a lightweight poster; clicking loads the real player in place,
// so heavy embeds only load on demand.
//
// Every provider is a plain, self-contained iframe that plays on a single click
// (the click is a user gesture, so autoplay=1 is honoured):
// - YouTube: youtube-nocookie /embed
// - Vimeo:   player.vimeo.com
// - TikTok:  official /player/v1 iframe (NOT the blockquote + embed.js embed,
//            which reflows the page and needs a second click)
// - Facebook: plugins/video.php
export default class extends Controller {
  static targets = ["frame"]
  static values = { src: String }

  play() {
    if (this.loaded || !this.srcValue) return
    this.loaded = true

    const src = this.srcValue + (this.srcValue.includes("?") ? "&" : "?") + "autoplay=1"

    const iframe = document.createElement("iframe")
    iframe.src = src
    iframe.className = "absolute inset-0 w-full h-full"
    iframe.setAttribute("frameborder", "0")
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
    )
    iframe.allowFullscreen = true

    // TikTok's player has a "watch on TikTok" tap target that navigates the TOP
    // window — i.e. it redirects the whole page away. Sandbox it with just the
    // flags the player needs to run; omitting allow-top-navigation makes hijacking
    // the page impossible, and allow-popups routes that link to a new tab instead.
    if (this.srcValue.includes("tiktok.com")) {
      iframe.setAttribute(
        "sandbox",
        "allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
      )
    }

    this.frameTarget.replaceChildren(iframe)
  }
}
